import { Box } from "@mui/material";
import ProductVariantForm from "pages/products/variants/ProductVariantForm";
import ProductVariantList from "pages/products/variants/ProductVariantList";

import React, { useState } from "react";

const ProductVariants = ({
  fullGrid = false,
  product_id,
  completed = null,
}) => {
  const [selectedVariant, setSelectedVariant] = useState(null);

  const handleEdit = (variant) => {
    setSelectedVariant(variant);
  };

  const handleSubmit = (data) => {
    if (selectedVariant) {
      // Dispatch update action here
      console.log("Updating variant", data);
    } else {
      // Dispatch create action here
      console.log("Creating new variant", data);
    }
    setSelectedVariant(null); // Reset after submission
  };

  return (
    <Box padding={1}>
      <ProductVariantList product_id={product_id} fullGrid={false} onEdit={handleEdit} />
      <ProductVariantForm
        product_id={product_id}
        fullGrid={false}
        variant={selectedVariant}
        onSubmit={handleSubmit}
      />
    </Box>
  );
};

export default ProductVariants;
